export const scrollToSection = (
  sectionRefs: any,
  id: string,
  focus: boolean
) => {
  if (sectionRefs.current[id]) {
    sectionRefs.current[id]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    focus && sectionRefs.current[id]?.focus(); // Optional: Focus for accessibility
  }
};
